const OSLO_TIME_ZONE = "Europe/Oslo";

export const SUPPORT_CHAT_HOURS_TEXT = "man-fre 10-20, lør 10-18";

const WEEKDAY_OPEN_MINUTES = 10 * 60;
const WEEKDAY_CLOSE_MINUTES = 20 * 60;
const SATURDAY_OPEN_MINUTES = 10 * 60;
const SATURDAY_CLOSE_MINUTES = 18 * 60;

const formatDatePartsInOslo = (date: Date) => {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: OSLO_TIME_ZONE,
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).formatToParts(date);

    const weekday = parts.find((part) => part.type === "weekday")?.value;
    const hour = Number(parts.find((part) => part.type === "hour")?.value);
    const minute = Number(parts.find((part) => part.type === "minute")?.value);

    return { weekday, hour, minute };
};

export const isSupportChatOpenNow = (date = new Date()) => {
    const { weekday, hour, minute } = formatDatePartsInOslo(date);

    if (!weekday || Number.isNaN(hour) || Number.isNaN(minute)) {
        return false;
    }

    const minutesSinceMidnight = hour * 60 + minute;

    if (["Mon", "Tue", "Wed", "Thu", "Fri"].includes(weekday)) {
        return minutesSinceMidnight >= WEEKDAY_OPEN_MINUTES && minutesSinceMidnight < WEEKDAY_CLOSE_MINUTES;
    }

    if (weekday === "Sat") {
        return minutesSinceMidnight >= SATURDAY_OPEN_MINUTES && minutesSinceMidnight < SATURDAY_CLOSE_MINUTES;
    }

    return false;
};
